/* AUVENNE Homepage V3 — final collection + cart behavior. */
(function(){
  'use strict';
  if(window.AUVENNEV3CollectionFinalBound)return;
  window.AUVENNEV3CollectionFinalBound=true;

  var isSv=(document.documentElement.lang||'').toLowerCase().indexOf('sv')===0;
  function ui(nl,sv){return isSv?sv:nl;}
  function rootPath(){var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';return r.charAt(r.length-1)==='/'?r:r+'/';}
  function cardFor(node){return node&&node.closest&&node.closest('[data-cro-card]');}
  function specialLabel(card){
    var handle=card&&card.getAttribute('data-product-handle');
    if(handle==='linea-open-ring')return ui('Personaliseer','Anpassa');
    return ui('Toevoegen','Lägg till');
  }
  function textForControl(control,card){
    if(!control)return '';
    if(control.getAttribute('aria-busy')==='true')return ui('Toevoegen…','Lägger till…');
    if(control.matches('a.cro-card__bag'))return specialLabel(card);
    /* A button disabled only while an AJAX add is running is NOT sold out. */
    if(control.matches('button.cro-card__bag:disabled')&&!control.closest('form[data-cro-add-form]'))return ui('Uitverkocht','Slutsåld');
    return ui('Toevoegen','Lägg till');
  }
  function enhanceControl(control,card){
    if(!control)return;
    control.classList.add('auv-v3-text-cta');
    var label=textForControl(control,card);
    if(control.textContent!==label)control.textContent=label;
    if(card&&card.getAttribute('data-product-handle')==='linea-open-ring')control.setAttribute('aria-label',specialLabel(card));
  }
  function setActiveSwatch(card,button){
    card.querySelectorAll('[data-cro-card-swatch]').forEach(function(swatch){swatch.setAttribute('aria-pressed',swatch===button?'true':'false');});
    var variant=button.getAttribute('data-variant-id');
    if(card.getAttribute('data-product-handle')==='legame-knot-cuff'){
      card.querySelectorAll('a.cro-card__image,a.cro-card__title').forEach(function(link){
        var url=new URL(link.href,location.href);url.searchParams.set('variant',button.getAttribute('data-variant-id'));link.href=url.toString();
      });
      var alternate=card.querySelector('.cro-card__second');if(alternate){alternate.hidden=true;alternate.style.display='none';}
    }
    var colour=button.getAttribute('data-colour-value')||'';
    var hidden=card.querySelector('[data-cro-card-variant]');
    if(hidden&&variant)hidden.value=variant;
    var select=card.querySelector('[data-cro-card-variant-select]');
    if(select){
      Array.prototype.forEach.call(select.options,function(option){
        if(!option.value){option.hidden=false;return;}
        var optionColour=option.getAttribute('data-colour-value')||'';
        option.hidden=!!colour&&!!optionColour&&optionColour!==colour;
      });
      select.value='';
    }
    var primary=card.querySelector('.cro-card__image > img:not(.cro-card__second)');
    var image=button.getAttribute('data-image');
    if(primary&&image){if(primary.getAttribute('src')!==image)primary.src=image;primary.removeAttribute('srcset');}
    var status=card.querySelector('[data-cro-status]');if(status&&status.textContent)status.textContent='';
  }
  function initCard(card){
    if(!card||card.hasAttribute('data-auv-v3-card-ready'))return;
    card.setAttribute('data-auv-v3-card-ready','');
    var label=card.querySelector('[data-cro-card-swatch-label]');if(label)label.hidden=true;
    var colours=card.querySelector('.cro-card__colours');if(colours)colours.hidden=true;
    card.querySelectorAll('.cro-card__bag').forEach(function(control){enhanceControl(control,card);});
    var active=card.querySelector('[data-cro-card-swatch][aria-pressed="true"]')||card.querySelector('[data-cro-card-swatch]');
    if(active)setActiveSwatch(card,active);
  }
  function initAll(scope){
    var root=scope&&scope.querySelectorAll?scope:document;
    if(root.matches&&root.matches('[data-cro-card]'))initCard(root);
    root.querySelectorAll('[data-cro-card]').forEach(initCard);
  }

  async function renderDrawer(data,trigger){
    var bridge=window.AUVENNECartDrawer;
    if(bridge&&typeof bridge.render==='function'){await bridge.render(data,trigger);return true;}
    var drawer=document.querySelector('cart-drawer');
    if(!drawer)return false;
    try{if(data&&data.sections&&data.sections['cart-drawer']&&typeof drawer.renderContents==='function')drawer.renderContents(data);}catch(_){}
    if(typeof drawer.open==='function'){drawer.open(trigger);return true;}
    return false;
  }

  async function addFromForm(form,button){
    if(!form||form.dataset.auvV3Adding==='1')return;
    if(!form.reportValidity())return;
    var id=form.querySelector('[name="id"]');
    if(!id||!id.value)return;

    form.dataset.auvV3Adding='1';
    var original=button&&button.textContent;
    if(button){button.disabled=true;button.setAttribute('aria-busy','true');button.textContent=ui('Toevoegen…','Lägger till…');}
    var status=form.querySelector('[data-cro-status]');
    if(status)status.textContent='';
    try{
      var body=new FormData(form);
      body.set('sections','cart-drawer,cart-icon-bubble');
      body.set('sections_url',location.pathname+location.search);
      var response=await fetch(rootPath()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:body});
      var data=await response.json();
      if(!response.ok||data.status||data.errors)throw new Error(data.description||data.message||ui('Toevoegen is niet gelukt.','Det gick inte att lägga till.'));
      if(status)status.textContent=ui('Toegevoegd.','Tillagt.');
      if(button)button.textContent=ui('Toegevoegd ✓','Tillagt ✓');
      var opened=await renderDrawer(data,button);
      if(!opened)throw new Error(ui('Je winkelmand kon niet worden geopend.','Varukorgen kunde inte öppnas.'));
    }catch(error){
      if(status)status.textContent=(error&&error.message)||ui('Toevoegen is niet gelukt.','Det gick inte att lägga till.');
    }finally{
      window.setTimeout(function(){
        delete form.dataset.auvV3Adding;
        if(button&&button.isConnected){
          button.disabled=false;
          button.removeAttribute('aria-busy');
          button.textContent=original||ui('Toevoegen','Lägg till');
        }
      },750);
    }
  }

  document.addEventListener('click',function(event){
    var swatch=event.target.closest&&event.target.closest('[data-cro-card-swatch]');
    if(swatch){
      var card=cardFor(swatch);if(!card||swatch.disabled)return;
      event.preventDefault();event.stopPropagation();setActiveSwatch(card,swatch);return;
    }
    var button=event.target.closest&&event.target.closest('.cro-card form[data-cro-add-form] button[type="submit"]');
    if(button&&button.form){event.preventDefault();event.stopPropagation();addFromForm(button.form,button);}
  },true);

  document.addEventListener('submit',function(event){
    var form=event.target;
    if(!(form&&form.matches&&form.matches('.cro-card form[data-cro-add-form]')))return;
    event.preventDefault();event.stopPropagation();
    addFromForm(form,event.submitter||form.querySelector('button[type="submit"]'));
  },true);

  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target||document);});
  function onMutations(mutations){
    /* Initialize only newly inserted cards. Re-scanning every text mutation
       resets selections and feeds the observer with its own CTA text writes. */
    mutations.forEach(function(mutation){
      mutation.addedNodes.forEach(function(node){
        if(node.nodeType===1)initAll(node);
      });
    });
  }
  new MutationObserver(onMutations).observe(document.documentElement,{childList:true,subtree:true});
})();
